import SelectEntriesModal from './SelectEntriesModal';

export default SelectEntriesModal;
